import { BehaviorSubject } from 'rxjs';
import { logger } from '@/services/logger.service';

export enum EBusEvent {
  // app logout
  APP_LOGOUT = 'APP_LOGOUT',

  // solgari API
  HUB_TOKEN_ERR = 'HUB_TOKEN',

  // sip events
  SIP_LOGIN_FAILED = 'SIP_LOGIN_FAILED',
  SIP_LOGIN_SUCCESS = 'SIP_LOGIN_SUCCESS',

  // dyn events
  DYN_NEEDED_POPUP = 'DYN_NEED_POPUP',
  DYN_VERIFIED_FAILED = 'DYN_VERIFIED_FAILED',
  DYN_TOKEN_ERR = 'DYN_TOKEN_ERR',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  SILENT_REFRESH = 'SILENT_REFRESH',

  // data events
  UPD_HISTORY = 'UPDATE_HISTORY',

  // signalR events
  NEW_CHAT_MESSAGE = 'NEW_CHAT_MESSAGE',

  // conference events
  UPD_ACTUAL_PARTICIPANTS = 'UPD_ACTUAL_PARTICIPANTS',
}

export interface IBusEvent {
  event: EBusEvent;
  payload?: unknown;
}

export class BusEvent {
  private static busEvent$: BehaviorSubject<IBusEvent> =
    new BehaviorSubject<IBusEvent>(null);

  public static getBus$() {
    return BusEvent.busEvent$;
  }

  public static sendEvent(data: IBusEvent) {
    logger.log(`[BusEvent] send event: `, data);
    BusEvent.busEvent$.next(data);
  }
}
